import { connect } from 'dva';
import { MetricEdit } from './Metrics/metric_edit';
import { DimensionEdit } from './Dimensions/dimension_edit';
import { namespace } from '../model';
import React from 'react';
import './analysis_condition.scss';
import { FilterEdit } from './filters/filter_edit';
import {useDblIntl} from "@/pages/datalab/utils/utils";

export default connect((state: any) => {
  const {
    filterLogic = 0,
    filterBasic = [],
    allFilters = [],
    allMetrics = [],
    allDimensions = [],
    optionFilters = [],
    optionMetrics = [],
    optionDimensions = [],
    columnFilters = [],
    columnMetrics = [],
    columnDimensions = [],
  } = state[namespace];
  return {
    filterLogic,
    filterBasic,
    allFilters,
    allMetrics,
    allDimensions,
    optionFilters,
    optionMetrics,
    optionDimensions,
    columnFilters,
    columnMetrics,
    columnDimensions,
  };
})(AnalysisCondition);

function AnalysisCondition(props: any) {
  const {
    filterLogic,
    filterBasic,
    allFilters,
    allMetrics,
    allDimensions,
    optionFilters,
    optionMetrics,
    optionDimensions,
    columnFilters,
    columnMetrics,
    columnDimensions,
  } = props;
  
  const { dblFormatMessage: explorationFormatMessage} = useDblIntl("exploration");

  const dispatchFun = (payload: any) => {
    props.dispatch({
      type: `${namespace}/save`,
      ...payload,
    });
  };
  return (
    <div className="body-context">
      <div className="body-context-bg">
        <div className="statistical-indicators">
          <div className="indicators-title">{explorationFormatMessage("metric")}</div>
          <div className="">
            <MetricEdit
              columns={columnMetrics}
              filterBasic={filterBasic}
              allMetrics={allMetrics}
              optionMetrics={optionMetrics}
              dispatchFun={dispatchFun}
              allFilters={allFilters}
              optionFilters={optionFilters}
            />
          </div>
        </div>
        <div className="statistical-indicators">
          <div className="indicators-title">{explorationFormatMessage("filter")}</div>
          <div className='context-three'>
            <FilterEdit
              columns={columnFilters}
              filterLogic={filterLogic}
              allFilters={allFilters}
              optionFilters={optionFilters}
              dispatchFun={dispatchFun}
            />
          </div>
        </div>
        <div className="statistical-indicators">
          <div className="indicators-title">{explorationFormatMessage("dimension")}</div>
          <div >
            <DimensionEdit
              columns={columnDimensions}
              allDimensions={allDimensions}
              optionDimensions={optionDimensions}
              dispatchFun={dispatchFun}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
